import React, { useState } from "react";
import "../../page_content.css";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

const CampusLife = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <h1 className="title">Life @ MANET</h1>
      <hr />
      <div className="page-content-container">
        {/* ---------- Accordion 1 ---------- */}
        <Accordion
          title="Sailing forward with new skills"
          isActive={activeIndex === 0}
          onClick={() => handleToggle(0)}
        />
        {activeIndex === 0 && (
          <div className="accordion-content">
            <p>
              At MANET Pune, we aspire to offer our students every possible
              opportunity to learn, grow, and flourish during their course. In
              this endeavor, we bring many events, visits, and trips to help
              students learn beyond academics. Whether cadets are preparing for
              merchant navy or marine engineering, a strong personality and
              character are essential to excel in the marine industry. That's
              why we focus highly on all-round development at every stage.
            </p>
            <p>
              Discipline is inculcated in every cadet as an integral part of
              this curriculum. Parade and drills along with hikes and treks are
              part of the routine. In order to maintain and nurture intellectual
              development, various industrial visits are arranged in consonance
              with the marine field. Cadets are encouraged to interact with
              their peers while presenting technical papers and attending
              symposiums on related issues and developments in the marine field.
              This helps the students to remain abreast of the latest
              developments in their respective fields. Extra lectures are
              conducted for cadets who need extra support in individual
              subjects. These lectures are arranged by our regular faculty when
              the number of failed cadets in the batch exceeds more than 30% in
              the end semester examinations.
            </p>
            <p>
              The MANET Pune faculty and team constantly strive to deliver a
              world-class learning and teaching environment, inside and outside
              the classrooms.
            </p>
          </div>
        )}

        {/* ---------- Accordion 2 ---------- */}
        <Accordion
          title="Enthusiastic participations in events & celebrations"
          isActive={activeIndex === 1}
          onClick={() => handleToggle(1)}
        />
        {activeIndex === 1 && (
          <div className="accordion-content">
            <p>
              Festive celebrations and events help cadets come together and work
              as a team towards a specific goal. It also breaks the monotony of
              academics and gives them something exciting to look forward to. We
              celebrate various festivals like Ganesh Festival, Durga Puja,
              Holi, and more in the hostel by arranging various programs and
              competitions to enhance their personal skills and organizing
              capabilities to bring up their personalities. National Maritime
              Day is also celebrated by arranging lectures by experts from the
              Marine industry. A blood donation camp is conducted in-house once
              a year in the month of February in association with renowned
              Hospitals in Pune city.
            </p>
            <p>
              Annual Social Inter-College competitions are organized by
              different colleges in Pune city which provides a platform to
              develop the personality of our cadets. Our cadets participate in
              different marine seminars / marine competitions, exhibitions which
              elevate their technical skills as well.
            </p>
          </div>
        )}

        {/* ---------- Accordion 3 ---------- */}
        <Accordion
          title="Role of holistic development & skills"
          isActive={activeIndex === 2}
          onClick={() => handleToggle(2)}
        />
        {activeIndex === 2 && (
          <div className="accordion-content">
            <p>
              The School of Holistic Development works to build SMART (Specific
              Measurable Attainable Realistic Time- bound) marine engineers
              through various modes of learning for the overall holistic
              development. The five methodologies have been channelized from
              'Pancha Kosh' arrangement of the Indian viewpoint of holistic
              development. The 'Pentagon' stresses physical, emotional,
              psychological, and intellectual development and spiritual
              Awakening.
            </p>
            <p>
              From polishing English Communication Skills, teaching foreign
              languages, honing creative expressions, instilling performing
              arts, offering spiritual awareness and giving back to the society
              through social initiatives; cadets emerge with a holistic
              personality that gives them an edge to be 'comprehensive global
              professionals' in the outside world.
            </p>
            <p>
              The MIT School of Corporate Innovation and Leadership (MIT SCIL)
              transform young cadets into impactful and responsible leaders who
              have the ability to lead multi-national organizations. MIT SCIL
              imbibes the practices of nurturing cadets to emerge as innovative
              global leaders of the next generation. This holistic approach to
              education helps them to work for the welfare of society. MIT SCIL
              creates change-champions within organizations by taking them
              through a carefully selected course of learning sessions to help
              them visualize, self-acknowledge, and unleash their true
              potential.
            </p>
            <div className="page-content-gallery">
              <img
                src="/assets/images/Miscellaneous/holistic1.webp"
                alt="Description 1"
                className="campuslife-img"
              />
              <img
                src="/assets/images/Miscellaneous/holistic2.webp"
                alt="Description 2"
                className="campuslife-img"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CampusLife;
